import { VT_NRF54L_HID_REPORT } from '../../shared/nordic/nrf54l'
import type { BaseDockProfile } from '../../shared/capabilities/base-command/profile'

/**
 * @file cmd.ts
 * @description Nordic nRF54L 底座私有命令表和 HID report 配置，只供对应底座设备装配 profile 使用。
 */

/**
 * VT_nrf54L_Base 底座协议命令表。
 *
 * 主要覆盖 ESPR/VPR 类底座。命令字按 1.0 的 cmd_VT_nrf54L_Base 迁移，
 * 相比 Telink_Base，这一族包含更多屏幕、子鼠标和分段固件版本能力。
 */
export const CMD_VT_NRF54L_BASE = {
  return_factory_settings: [0xad],
  get_work_mode: [0xa7],
  get_firmware: [0xb0],
  read_eeprom: [0xa4],
  write_eeprom: [0xa5],
  factory_update: [0xa8],
  set_light_effect: [0xc0],
  get_light_effect: [0xc1],
  set_screen_light_effect: [0xf0],
  get_screen_light_effect: [0xf1],
  show_effect: [0xc5],
  switch_light: [0xc6],
  set_current_light_effect: [0xc2],
  get_current_light_effect: [0xc3],
  set_current_screen_light_effect: [0xf2],
  get_current_screen_light_effect: [0xf3],
  get_specs: [0xc4],
  get_img_name: [0xd0],

  //配对
  switch_work_mode: [0xa0],
  code_match_mode: [0xa1, 0x8f],
  clear_code_status: [0xa1, 0x82],
  device_pairing_status: [0xa1, 0x01],
} as const

/** VT_nrf54L_Base 使用的 HID report / ACK 配置。 */
export const VT_NRF54L_BASE_PROTOCOL_CONFIG = {
  // ESPR/VPR 系列底座沿用 Nordic nRF54L 平台共享的 HID report 配置。
  reportId: VT_NRF54L_HID_REPORT.outputReportId,
  featureReportId: VT_NRF54L_HID_REPORT.featureReportId,
  busyAck: VT_NRF54L_HID_REPORT.busyAck,
  okAck: VT_NRF54L_HID_REPORT.okAck,
} as const

export const VT_NRF54L_BASE_PROFILE: BaseDockProfile = {
  name: 'VT_nrf54L_Base',
  config: VT_NRF54L_BASE_PROTOCOL_CONFIG,
  commands: CMD_VT_NRF54L_BASE,
  childReportOffset: 1,
}

export type VTNrf54LBaseCommand = (typeof CMD_VT_NRF54L_BASE)[keyof typeof CMD_VT_NRF54L_BASE]
